<template>
  <div>
    <el-table
      class="m-top-5 table-header-th-top-0"
      width="100%"
      :data="result"
    >
      <!-- スマートロック -->
      <el-table-column
        class-name="col-7"
        prop="name"
        :label="$t('label.system.meetingRoom.edit.smartName')"
      />

      <!--  削除バータン  -->
      <el-table-column align="right" class-name="col-3" >
        <div slot-scope="scope">
          <sp-smart-button
            class="delete-button"
            v-show="deleteFlag"
            @click="handleDeleteAction(scope.row, scope.$index)">
            {{$t("button.common.data.delete")}}
          </sp-smart-button>
        </div>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const EVENT_DELETE = "on-delete";
import SpSmartButton from "@/components/common/sp-smart-button"

export default {
  name: "MeetingRoomACForDetailResultBeautify",
  components: {
    SpSmartButton: SpSmartButton
  },
  data() {
    return {
      showHeader: false,
    };
  },
  props: {
    result: Array,
    deleteFlag:Boolean
  },
  methods: {
    //削除バータン
    handleDeleteAction(ASData, index) {
      this.$emit(EVENT_DELETE, ASData.id, index);
    },
  },
};
</script>

<style scoped>
.delete-button {
  text-align: center;
  width: 60px;
  height: 32px;
  margin: 5px;
}
::v-deep .my-button {
  padding: 0px;
}
</style>
